import React from "react";
import { IoClose } from "react-icons/io5";

export default function Popup({
  children,
  title,
  subtitle = null,
  onClose = null,
  top = false,
  maxWidth = "660px",
}) {
  return (
    <div
      className={`fixed flex flex-col items-center  left-0 w-full h-full z-[9999] p-3
      ${top ? "top-[10%]" : "justify-center top-0"}`}
    >
      <div
        className="fixed top-0 w-full h-screen bg-black opacity-40 -z-10"
        onClick={onClose}
      ></div>
      <div
        className="flex relative flex-col p-8 mt-0 w-full bg-white rounded-md md:mt-30"
        style={{ maxWidth }}
      >
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-5 right-5 btn btn-icon btn-icon-md btn-goast"
          >
            <div className="text-2xl">
              <IoClose />
            </div>
          </button>
        )}
        <div className="text-lg font-semibold md:text-xl">{title}</div>
        {subtitle && (
          <div className="mt-2 text-sm md:text-sm text-altgray-600">
            {subtitle}
          </div>
        )}
        <div className="mt-5">{children}</div>
      </div>
    </div>
  );
}
